// Manage left-column presentation: expanded width clamp + persist, and per-entity collapse.
// Collapse is a separate flag — never store width 0; restore the last clamped width on expand.

export const MANAGE_LEFT_RAIL_DEFAULT_WIDTH = 300;
export const MANAGE_LEFT_RAIL_MIN_WIDTH = 240;
export const MANAGE_LEFT_RAIL_MAX_WIDTH = 520;
/** Thin strip that holds the expand chevron. Not written to width storage. */
export const MANAGE_LEFT_COLUMN_COLLAPSED_WIDTH = 40;

const manageLeftRailWidthKey = 'wb-manage-left-panel-width';
// Read-only fallback: the generic manage host used to persist under the Jobs-specific key, so
// existing users keep their saved rail width. Writes only ever go to manageLeftRailWidthKey.
const legacyManageLeftRailWidthKey = 'wb-manage-job-pro-left-panel-width';
const manageLeftColumnCollapsedKeyPrefix = 'wb-manage-left-panel-collapsed:';

export function clampManageLeftRailWidth(value: number): number {

  return Math.min(MANAGE_LEFT_RAIL_MAX_WIDTH, Math.max(MANAGE_LEFT_RAIL_MIN_WIDTH, Math.round(value)));
}

export function readManageLeftRailWidth(): number {

  if (typeof localStorage === 'undefined') return MANAGE_LEFT_RAIL_DEFAULT_WIDTH;
  const stored = Number(localStorage.getItem(manageLeftRailWidthKey) ?? localStorage.getItem(legacyManageLeftRailWidthKey));
  return Number.isFinite(stored) && stored > 0 ? clampManageLeftRailWidth(stored) : MANAGE_LEFT_RAIL_DEFAULT_WIDTH;
}

export function writeManageLeftRailWidth(value: number): void {

  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(manageLeftRailWidthKey, String(value));
}

/** Clears both keys so the legacy fallback cannot resurrect the width the user just reset. */
export function clearManageLeftRailWidth(): void {

  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(manageLeftRailWidthKey);
  localStorage.removeItem(legacyManageLeftRailWidthKey);
}

export function manageLeftColumnDisplayWidth(collapsed: boolean, expandedWidth: number): number {

  return collapsed ? MANAGE_LEFT_COLUMN_COLLAPSED_WIDTH : expandedWidth;
}

function manageLeftColumnCollapsedKey(entity: string): string {

  return `${manageLeftColumnCollapsedKeyPrefix}${entity}`;
}

export function readManageLeftColumnCollapsed(entity: string | null | undefined): boolean {

  if (!entity || typeof localStorage === 'undefined') return false;
  return localStorage.getItem(manageLeftColumnCollapsedKey(entity)) === '1';
}

export function writeManageLeftColumnCollapsed(entity: string | null | undefined, collapsed: boolean): void {

  if (!entity || typeof localStorage === 'undefined') return;
  const key = manageLeftColumnCollapsedKey(entity);
  if (collapsed) localStorage.setItem(key, '1');
  else localStorage.removeItem(key);
}
